// @flow
import $ from "jquery";

export default (context: Object, data: Object) => {
	const dfd = $.Deferred();

	setTimeout(() => {
		dfd.resolveWith(context, [data]);
	}, 1000);

	return dfd.promise();
};
